import { StepType, useTour } from '@reactour/tour';
import { useProvider } from 'utils/providers/Provider';
import { useLocation } from 'react-router-dom';
import Content from 'ui/components/common/Tour/Content';
import { TOUR_SELECTOR } from 'ui/partials/Tour';

const useGetHowToManageDealSteps = () => {
  const { dispatch, state } = useProvider();
  const { setIsOpen, setSteps, setCurrentStep } = useTour();
  const isCollapsed = state?.collapse;
  const { pathname } = useLocation();

  const isInDealsPage = pathname.includes('deals');

  const viewManagedDealsSteps: StepType[] = [
    ...(!isInDealsPage
      ? ([
          {
            content: 'Go to the Sales menu tab',
            selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.MENU}"]`,
            position: 'right',
            action: (node) => {
              node?.addEventListener(
                'click',
                function () {
                  setTimeout(() => setCurrentStep(1), 500);
                },
                false,
              );
            },
            styles: {
              arrow: (base) => ({
                ...base,
                visibility: 'hidden',
              }),
            },
          },
        ] as StepType[])
      : []),
    ...(!isInDealsPage
      ? ([
          {
            content: 'Then select Deals to view the Deals page',
            position: 'right',
            selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.DEAL.SUBMENU}"]`,
            action: (node) => {
              node?.addEventListener(
                'click',
                function () {
                  setTimeout(() => setCurrentStep(2), 500);
                },
                false,
              );
            },
            styles: {
              arrow: (base) => ({
                ...base,
              }),
            },
          },
        ] as StepType[])
      : []),
    {
      content: (props) => (
        <Content
          {...props}
          // eslint-disable-next-line max-len
          content="You can locate a deal by filtering deals by deal owner, date, and associated contact"
          hideNote
        />
      ),
      stepInteraction: false,
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.DEAL.MANAGE.DEALS_FILTER}"]`,
    },
    {
      content:
        'Select the deal by clicking on the card and review the information on the screen.',
      position: 'right',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.DEAL.MANAGE.DEALS_CARD}"]`,
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(
              () => setCurrentStep(viewManagedDealsSteps.length === 8 ? 4 : 2),
              500,
            );
          },
          false,
        );
      },
      styles: {
        arrow: (base) => ({
          ...base,
        }),
      },
    },
    {
      content: 'To update deal details, click on the three dots.',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.DEAL.MANAGE.THREE_DOTS_BUTTON}"]`,
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(
              () => setCurrentStep(viewManagedDealsSteps.length === 8 ? 5 : 3),
              500,
            );
          },
          false,
        );
      },
      styles: {
        popover: (base) => ({ ...base, marginTop: 33, marginLeft: 30 }),
      },
    },
    {
      content: 'Next to the deal name and select Edit.',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.DEAL.MANAGE.DEAL_COMPOSER_EDIT}"]`,
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(
              () => setCurrentStep(viewManagedDealsSteps.length === 8 ? 6 : 4),
              500,
            );
          },
          false,
        );
      },
      styles: {
        popover: (base) => ({ ...base, marginTop: 50, marginLeft: 120 }),
      },
    },
    {
      content: (props) => (
        <Content
          {...props}
          type="Edit Deal"
          // eslint-disable-next-line max-len
          content="Make necessary changes to the deal such as the deal name, stage, amount, closed date, deal type, and deal owner."
        />
      ),
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.DEAL.MANAGE.DEAL_COMPOSER_FORM}"]`,
      stepInteraction: false,
      styles: {
        popover: (base) => ({ ...base, top: '-52%' }),
      },
    },
    {
      content: 'Click Save and you are done.',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.DEAL.MANAGE.DEAL_COMPOSER_SAVE}"]`,
      action: (node: any) => {
        node?.addEventListener(
          'click',
          function () {
            setCurrentStep(0);
            setSteps?.([]);
            window.location.href = '/';
          },
          false,
        );
      },
      styles: {
        popover: (base) => ({ ...base, marginLeft: -100 }),
      },
    },
  ];

  const showManageDealSteps = () => {
    if (isCollapsed && !isInDealsPage) {
      dispatch?.({ type: 'toggleSidebar' });
    }

    setTimeout(() => {
      setSteps?.(viewManagedDealsSteps);
      setIsOpen(true);
    }, 300);
  };

  return showManageDealSteps;
};

export default useGetHowToManageDealSteps;
